import {
	Button,
	Dialog,
	DialogActions,
	DialogClose,
	DialogContent,
	DialogPopup,
	DialogTitle,
} from '@huntington/honeycomb';
import { Typography } from '@mui/material';
import {
	CONTACT_US_MESSAGE,
	CONTACT_US_OK_BUTTON,
	CONTACT_US_TITLE,
} from '../../../constants/messages';

type ContactUsModalProps = {
	open: boolean;
	onClose: () => void;
};

export const ContactUsModal = ({ open, onClose }: ContactUsModalProps) => {
	return (
		<Dialog
			open={open}
			onOpenChange={(nextOpen: boolean) => {
				if (!nextOpen) onClose();
			}}
		>
			<DialogPopup
				style={{
					display: 'flex',
					flexDirection: 'column',
					width: '27.75rem',
					height: '14.75rem',
					minWidth: '27.75rem',
					maxWidth: '27.75rem'
				}}
			>
				<DialogTitle>
					<DialogClose />
					{CONTACT_US_TITLE}
				</DialogTitle>

				<DialogContent>
					<div style={{ paddingLeft: 5, paddingRight: 5 }}>
						<Typography variant="body1">{CONTACT_US_MESSAGE}</Typography>
					</div>
				</DialogContent>

				<DialogActions>
					<Button autoFocus onClick={onClose}>
						{CONTACT_US_OK_BUTTON}
					</Button>
				</DialogActions>
			</DialogPopup>
		</Dialog>
	);
};
